import React, {useEffect} from 'react';
import styles from './App.module.scss';
import Container from './containers/Container/Container';
import * as actionTypes from './redux/actions/actionTypes';
import {useDispatch} from 'react-redux';

function App(props) {

  const dataPath = props.dataPath;
  const documentiPreventivatore = props.documentiPreventivatore;
  const linkSicurezza = props.linkSicurezza;
  const linkCookies = props.linkCookies;
  const linkPrivacy = props.linkPrivacy;
  const linkHome = props.linkHome;
  const linkPreventivatore = props.linkPreventivatore;
  const linkInformativa = props.linkInformativa;
  const linkTrasparenza = props.linkTrasparenza;
  const linkFiliali = props.linkFiliali;
  const linkCondizioniPolizza = props.linkCondizioniPolizza;
  const docAssicurazione1 = props.docAssicurazione1;
  const docAssicurazione2 = props.docAssicurazione2;
  const docAssicurazione3 = props.docAssicurazione3;
  const docAssicurazione4 = props.docAssicurazione4;
  const accordions = props.accordions;

  const dispatch = useDispatch();

  useEffect( () => {
    dispatch({type: actionTypes.INIT_DATA_PATH, payload: dataPath});
    dispatch({type: actionTypes.INIT_DOCUMENTS,
            documentiPreventivatore:documentiPreventivatore,
            linkSicurezza:linkSicurezza,
            linkCookies:linkCookies,
            linkPrivacy:linkPrivacy,
            linkHome:linkHome,
            linkPreventivatore: linkPreventivatore,
            linkInformativa: linkInformativa,
            linkTrasparenza:linkTrasparenza,
            linkFiliali:linkFiliali,
            linkCondizioniPolizza: linkCondizioniPolizza,
            docAssicurazione1: docAssicurazione1,
            docAssicurazione2: docAssicurazione2,
            docAssicurazione3: docAssicurazione3,
            docAssicurazione4: docAssicurazione4,
            accordions: accordions
          });
  },[]); // eslint-disable-line

  return (
    <Container className={styles.App} />
  );
}

export default App;